import { useMutation, useQueryClient } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

import { updateProfile } from "../api/userProfileApi";
import { userProfileKeys } from "../api/userProfileKeys";

/**
 * @param {Object} options
 * @param {Function} [options.onSuccess] - Callback ejecutado tras invalidar el cache y mostrar el Swal de éxito.
 *   Útil para que el componente padre llame `setUpdate(false)` y vuelva al modo vista.
 */
export const useUpdateProfile = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateProfile,
        onSuccess: () => {
            // Invalida el cache del perfil para que la vista se refresque con datos frescos.
            queryClient.invalidateQueries({ queryKey: userProfileKeys.profile() });

            const title = t("profileUpdate");
            const subtitle = t("doneSuccessfully", { a: "a" });

            Swal.fire(title, subtitle, "success").then(() => {
                if (onSuccess) onSuccess();
            });
        },
        onError: () => {
            Swal.fire(
                t("profileUpdate"),
                t("internalError"),
                "error"
            ).then();
        },
    });
};
